var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"closeBar"},[_c('img',{attrs:{"src":_vm.closeImg,"alt":""},on:{"click":_vm.handleClose}})]),_vm._v(" "),_c('div',{staticClass:"js-video [vimeo, widescreen]",style:(_vm.frameStyle)},[_c('video',{attrs:{"src":_vm.url,"frameborder":"0","allowfullscreen":"","controls":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7a35af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpiVideo/index.vue
// module id = null
// module chunks = 